import './bootstrap';
import {createRoot} from 'react-dom/client';
import {createInertiaApp} from '@inertiajs/react'
import i18n from "i18next";
import {initReactI18next} from 'react-i18next';
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
const appName = import.meta.env.VITE_APP_NAME || 'Lense';


createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: name => {
        const pages = import.meta.glob('./Pages/**/*.jsx', {eager: true})
        return pages[`./Pages/${name}.jsx`]
    }, setup({el, App, props}) {
        i18n
            .use(initReactI18next) // passes i18n down to react-i18next
            .init({
                // the translations
                // (tip move them in a JSON file and import them,
                // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
                resources: {
                    en: {
                        translation: {}
                    },
                    nl: {
                        translation: {
                            "Tap open below to join.": "Klik hieronder om te joinen.",
                            "Continue": "Doorgaan",
                            "Join event": "Event joinen",
                            "Please enter your full name to join this event.": "Vul je naam in om door te gaan.",
                            "Full name": "Naam",
                            "Tap here to open camera": "Klik hier om de camera te openen",
                            "Tap here to open camera and take pictures for the album.": "Klik hier om de camera te openen en foto's te maken voor het album",
                            "Failed to upload. Do you have an internet connection?": "Uploaden mislukt. Heb je een internet verbinding?",
                            'Uploaded ✅': "Geupload ✅",
                            'Uploading photo...': 'Aan het uploaden...',
                            'You have no more photos left': "Je heb geen foto's meer over",
                            "Receive album link": "Album bekijken",
                            "enterMailReveal": "Vul je email adres in om een link naar het album te ontvangen zodra het op <1>{{reveal}}</1> onthult",
                            "revealComeBack": "De foto's worden onthult op <1>{{reveal}}</1>. Kom dan terug.",
                            "Otherwise we won't be able to send you a link to the album once it reveals!": "Anders kunnen we geen link versturen naar het album zodra het onthult.",
                            "Enter your email address to receive a link to the album so you can easily access it in the future.": "Vul je email adres in om een link naar het album te ontvangen om gemakkelijk het album te bekijken in de toekomst.",
                            "Notify me": "Stuur mail zodra het zover is!",
                            "Email Address": "E-mail adres",
                            "Looks like you already have an account": "Het lijkt erop dat je al een Lense account hebt.",
                            "We have just emailed you a verification code. Please enter it down below.": "We hebben je zojuist een code gestuurd via de mail. Vul deze hieronder in",
                            "Verification code": "Verificatiecode",
                            "We have to verify your email to continue.": "We moeten je e-mail adres verifieren om door te gaan.",
                            "Verify code": "Verifieer",
                            "Upload your photos": "Foto's uploaden",
                            "Filter effect": "Filter effect",
                            "The organizer of this event chose to hide other people's photos. You can only view your own photos.": "De organisator heeft ervoor gekozen om (voor nu) de foto's te verbergen. Je kan op dit moment enkel je eigen foto's bekijken."
                        }
                    },
                    de: {
                        translation: {
                            "Tap open below to join.": "Tippe unten auf Öffnen, um beizutreten.",
                            "Continue": "Weiter",
                            "Join event": "Event beitreten",
                            "Please enter your full name to join this event.": "Bitte gib deinen vollständigen Namen ein, um diesem Event beizutreten.",
                            "Full name": "Vollständiger Name",
                            "Tap here to open camera": "Tippe hier, um die Kamera zu öffnen",
                            "Tap here to open camera and take pictures for the album.": "Tippe hier, um die Kamera zu öffnen und Fotos für das Album zu machen.",
                            "Failed to upload. Do you have an internet connection?": "Upload fehlgeschlagen. Hast du eine Internetverbindung?",
                            "Photo uploaded ✅": "Foto hochgeladen ✅",
                            "Uploading photo...": "Foto wird hochgeladen...",
                            "You have no more photos left": "Du hast keine Fotos mehr übrig",
                            "Receive album link": "Album-Link erhalten",
                            "enterMailReveal": "Gib deine E-Mail-Adresse ein, um einen Link zum Album zu erhalten, sobald es am <1>{{reveal}}</1> enthüllt wird.",
                            "revealComeBack": "Die Fotos werden am <1>{{reveal}}</1> enthüllt. Komm dann zurück.",
                            "Otherwise we won't be able to send you a link to the album once it reveals!": "Andernfalls können wir dir keinen Link zum Album senden, sobald es enthüllt wird.",
                            "Enter your email address to receive a link to the album so you can easily access it in the future.": "Gib deine E-Mail-Adresse ein, um einen Link zum Album zu erhalten, damit du es in Zukunft leicht aufrufen kannst.",
                            "Notify me": "Benachrichtige mich",
                            "Email Address": "E-Mail-Adresse",
                            "Looks like you already have an account": "Es sieht so aus, als hättest du bereits ein Lense-Konto.",
                            "We have just emailed you a verification code. Please enter it down below.": "Wir haben dir gerade einen Bestätigungscode per E-Mail geschickt. Bitte gib ihn unten ein.",
                            "Verification code": "Bestätigungscode",
                            "We have to verify your email to continue.": "Wir müssen deine E-Mail-Adresse verifizieren, um fortzufahren.",
                            "Verify code": "Code bestätigen",
                            "Upload your photos": "Lade deine Fotos hoch",
                            "Filter effect": "Filtereffekt",
                            "The organizer of this event chose to hide other people's photos. You can only view your own photos.": "Der Veranstalter hat entschieden, die Fotos anderer zu verbergen. Du kannst nur deine eigenen Fotos sehen."
                        }
                    },
                    es: {
                        translation: {
                            "Tap open below to join.": "Toca abrir abajo para unirte.",
                            "Continue": "Continuar",
                            "Join event": "Unirse al evento",
                            "Please enter your full name to join this event.": "Por favor, introduce tu nombre completo para unirte a este evento.",
                            "Full name": "Nombre completo",
                            "Tap here to open camera": "Toca aquí para abrir la cámara",
                            "Tap here to open camera and take pictures for the album.": "Toca aquí para abrir la cámara y tomar fotos para el álbum.",
                            "Failed to upload photo. Do you have an internet connection?": "Error al subir. ¿Tienes conexión a internet?",
                            "Photo uploaded ✅": "Foto subida ✅",
                            "Uploading photo...": "Subiendo foto...",
                            "You have no more photos left": "No te quedan más fotos",
                            "Receive album link": "Recibir enlace del álbum",
                            "enterMailReveal": "Introduce tu correo electrónico para recibir un enlace al álbum cuando se revele el <1>{{reveal}}</1>.",
                            "revealComeBack": "Las fotos se revelarán el <1>{{reveal}}</1>. Vuelve entonces.",
                            "Otherwise we won't be able to send you a link to the album once it reveals!": "De lo contrario, no podremos enviarte un enlace al álbum cuando se revele.",
                            "Enter your email address to receive a link to the album so you can easily access it in the future.": "Introduce tu correo electrónico para recibir un enlace al álbum y acceder fácilmente en el futuro.",
                            "Notify me": "Notificarme",
                            "Email Address": "Correo electrónico",
                            "Looks like you already have an account": "Parece que ya tienes una cuenta de Lense.",
                            "We have just emailed you a verification code. Please enter it down below.": "Te hemos enviado un código de verificación por correo electrónico. Por favor, introdúcelo abajo.",
                            "Verification code": "Código de verificación",
                            "We have to verify your email to continue.": "Debemos verificar tu correo electrónico para continuar.",
                            "Verify code": "Verificar código",
                            "Upload your photos": "Sube tus fotos",
                            "Filter effect": "Efecto de filtro",
                            "The organizer of this event chose to hide other people's photos. You can only view your own photos.": "El organizador de este evento decidió ocultar las fotos de otras personas. Solo puedes ver tus propias fotos."
                        }
                    }
                },
                lng: props.initialPage.props.locale,
                fallbackLng: "en",

                interpolation: {
                    escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
                }
            });
        const root = createRoot(el);


        root.render(
            <App {...props} />);
    },
    progress: {
        color: '#4B5563',
    },
});
